import { Post } from '../types';
import { getAuthorInfo, getPostContent, getEngagementMetrics, getPostTime, hasMedia, isThread, handlePostClick } from '../lib/postUtils';
import { extractHashtags } from '../lib/utils';

export interface PostActionHandlers {
  onNoteUpdate?: (postId: number, note: string) => void;
  onCategoryUpdate?: (postId: number, category?: any) => void;
  onPostDelete?: (postId: number) => void;
  onPostArchive?: (postId: number) => void;
  onFavouriteToggle?: (postId: number, isFavourite: boolean) => void;
  favouriteStates?: { [key: string]: boolean };
}

export interface PostDisplayData {
  authorInfo: any;
  content: string;
  hashtags: string[];
  cleanedText: string;
  metrics: any;
  postTime: string;
  hasMedia: boolean;
  isThread: boolean;
  truncatedText: string;
  isTruncated: boolean;
}

export const getPostDisplayData = (post: Post, truncateLength: number = 256): PostDisplayData => {
  const authorInfo = getAuthorInfo(post);
  const content = getPostContent(post);
  const { hashtags, cleanedText } = extractHashtags(content || '');
  const metrics = getEngagementMetrics(post);
  const postTime = getPostTime(post);
  const hasMediaFlag = hasMedia(post);
  const isThreadFlag = isThread(post);
  const truncatedText = cleanedText.length > truncateLength 
    ? cleanedText.substring(0, truncateLength) + '...' 
    : cleanedText;
  const isTruncated = cleanedText.length > truncateLength;

  return {
    authorInfo,
    content: content || '',
    hashtags,
    cleanedText,
    metrics,
    postTime,
    hasMedia: hasMediaFlag,
    isThread: isThreadFlag,
    truncatedText,
    isTruncated
  };
};

export const handlePostClickAction = (post: Post) => {
  handlePostClick(post);
};

export const getFavouriteState = (post: Post, favouriteStates?: { [key: string]: boolean }): boolean => {
  return favouriteStates?.[post.id.toString()] ?? post.is_favorite ?? false;
};
